/**
 * 会话失效确认弹窗宿主：H5 挂到 body，不依赖 Layout（跟单明细等子页也能弹）。
 */
import { createApp, h, type Plugin } from 'vue';
import type { Pinia } from 'pinia';
import SessionAuthPrompt from '@/components/session-auth-prompt/index.vue';

let hostMounted = false;

function ensureSessionAuthHost(pinia: Pinia, i18n: Plugin) {
  if (hostMounted || typeof document === 'undefined') return;
  if (document.getElementById('app-session-auth-root')) {
    hostMounted = true;
    return;
  }

  const el = document.createElement('div');
  el.id = 'app-session-auth-root';
  document.body.appendChild(el);

  const hostApp = createApp({
    render: () => h(SessionAuthPrompt),
  });
  hostApp.use(pinia);
  hostApp.use(i18n);
  hostApp.config.warnHandler = () => undefined;
  hostApp.mount(el);
  hostMounted = true;
}

export function installSessionAuthPrompt(pinia: Pinia, i18n: Plugin): void {
  if (typeof document === 'undefined') return;
  const mount = () => ensureSessionAuthHost(pinia, i18n);
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount, { once: true });
}
